class TabComponent extends HTMLElement {
  constructor() {
    super();

    this.tabHeadings = this.querySelectorAll('.tab-heading');
    this.tabContents = this.querySelectorAll('.tab_content');

    // Bind the click event
    this.tabHeadings.forEach(tab => {
      tab.addEventListener('click', () => this.handleTabClick(tab));
    });
  }

  handleTabClick(selectedTab) {
    this.tabHeadings.forEach(tab => tab.classList.remove('active'));
    this.tabContents.forEach(content => content.classList.add('hidden'));

    // Add active class to the clicked tab and show the corresponding content
    selectedTab?.classList.add('active');
    const targetContent = this.querySelector(selectedTab.dataset.target);
    if (targetContent) {
      targetContent.classList.remove('hidden');
    }
  }
}

customElements.define('tab-component', TabComponent);

